import { render, staticRenderFns } from "./DataUpdate.vue?vue&type=template&id=1c18790e&"
import script from "./DataUpdate.vue?vue&type=script&lang=js&"
export * from "./DataUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports